import * as STD from '@emersya/mpa-std-lib';
import CM       from '@emersya/mpa-components-manager-lib';

export interface IImageComponentConfiguration extends CM.DOMComponent.IConfiguration {
	URL? : string;
};

export class ImageComponent extends CM.DOMComponent<
	HTMLImageElement,
	ImageComponent,
	IImageComponentConfiguration
>
{
	component_DOM : HTMLImageElement;

	update(source : string) {
		this.component_DOM.setAttribute('src', source);
	};

	setSrc(URL : string) {
		this.component_DOM.setAttribute('src', URL);
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IImageComponentConfiguration
	)
	{
		super(descriptor, configuration);
		if (!this.component_hasTranslation('name')) {
			this.component_throwUserError('Translation<name> not defined!');
		}
		this.component_DOM = <HTMLImageElement> STD.DOM.factory({
			tag :        'img',
			attributes : {
				'data-translation-attr' : 'alt:' + <string> this.component_getTranslationId('name')
			}
		});
		if (configuration.URL) {
			this.setSrc(configuration.URL);
		}
	};
};
export namespace NS {
	export const Component = ImageComponent;
	export type Component = ImageComponent;
	export type Configuration = IImageComponentConfiguration;
}
CM.declare({
	id :   'image',
	type : ImageComponent
});
